<template>
  <div class="p-5">
    <b-row class="mt-4 pb-4">
      <b-col align-self="center">
        <h4>Feiertagsübersicht</h4>
      </b-col>
    </b-row>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />
    <!-- Search Section -->
    <div class="mt-2">
      <!--ROW 1-->
      <b-row>
        <b-col cols="2">
          <label class="mx-3 mt-4 defaultLabel"> Jahr </label>
          <v-select
            :disabled="yearSelection.length <= 1"
            :items="yearSelection"
            :value="selectedYear"
            @change="setDateRangetoYear"
          />
        </b-col>
        <b-col cols="2">
          <label class="mx-3 mt-4 defaultLabel"> Ort </label>
          <v-autocomplete
            :value="selectedCityFilter"
            :items="cityFilterOptions"
            clearable
            item-text="text"
            item-value="path"
            label="Filter nach Ort"
            @change="changeSelectedLocationFilter"
          />
        </b-col>
      </b-row>

      <!--ROW 2-->
      <b-row>
        <b-col cols="2">
          <label class="mx-3 mt-4 defaultLabel"> Sprache </label>
          <v-select
            :items="languageOptions"
            :value="selectedLanguage"
            item-text="text"
            item-value="value"
            @change="changeLanguage"
          />
        </b-col>
        <b-col cols="2">
          <label class="mx-3 mt-4 defaultLabel"> Gruppierung </label>
          <v-select
            :items="groupingOptions"
            :value="selectedGroupingOption"
            item-text="text"
            item-value="value"
            @change="changeGrouping"
          />
        </b-col>
        <b-col cols="1">
          <label class="mt-4 defaultLabel float-right"> Von </label>
        </b-col>
        <b-col cols="2">
          <u-date-picker
            v-model="searchFrom"
            label=""
            @change="getCalenders"
          />
        </b-col>
        <b-col cols="1">
          <label class="mt-4 defaultLabel float-right"> Bis </label>
        </b-col>
        <b-col cols="2">
          <u-date-picker
            v-model="searchTo"
            label=""
            @change="getCalenders"
          />
        </b-col>
      </b-row>
    </div>
    <!-- END Search Section -->

    <!-- Table Section -->
    <div class="pt-5">
      <div class="ml-4 mr-4">
        <v-flex
          v-if="isLoading"
          justify-center
        >
          <u-loader />
        </v-flex>
        <div
          v-else
          class="calenderOverview-wrapper"
        >
          <table class="w-100 calenderOverview mt-4">
            <thead>
              <tr>
                <th>Datum</th>
                <th>Orts-Genauigkeit</th>
                <th>Code</th>
                <th v-if="selectedGroupingOption === 3">
                  Feiertag
                </th>
                <th>Ort</th>
                <th>Feiertage am Ort</th>
                <th>Feiertage total</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="calendar in resourceCalendars"
                :key="calendar.id"
              >
                <td class="custom-td">
                  {{ calendar.dateValue }}
                </td>
                <td class="custom-td">
                  {{
                    locationAccurationOptions[
                      calendar.locationInformationAccuration - 1
                    ]
                      ? locationAccurationOptions[
                        calendar.locationInformationAccuration - 1
                      ].text
                      : ""
                  }}
                </td>
                <td class="custom-td">
                  {{ calendar.locationCode }}
                </td>
                <td
                  v-if="selectedGroupingOption === 3"
                  class="custom-td"
                >
                  {{ calendar.description }}
                </td>
                <td class="custom-td">
                  {{ calendar.locationName }}
                </td>
                <td class="custom-td">
                  {{ calendar.publicHolidayDaysForLocation }}
                </td>
                <td class="custom-td">
                  {{ calendar.publicHolidayDaysTotal }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- END Table Section -->
  </div>
</template>

<script>
import {
  GetPublicHolidayYears,
  GetGroupByOptions,
  GetLocationAccurationOptions,
  GetConfigPublicHolidays,
} from "@/services/minimum.wage.services/resourceCalendar.minimum.wage";
import { GetPublicholidayConfig } from "@/services/minimum.wage.services/holidays.minimum.wages";
import { CreateMiloTreeView } from "@/helpers/TreeViewHelper.js";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";
import UDatePicker from "@/components/common/UDatePicker.vue";
import { GetCitiesVNext } from "@/services/contract.edition.cantons.service.js";

export default {
  components: {
    UDatePicker,
  },
  filters: {
    formatDate: function (value) {
      if (!value) return "";
      const date = new Date(value);
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      return `${day < 10 ? "0" : ""}${day}.${
        month < 10 ? "0" : ""
      }${month}.${year}`;
    },
    validateAndGetValue: function (inputObj, key) {
      if (
        !inputObj ||
        typeof inputObj !== "object" ||
        typeof key === "undefined"
      ) {
        return ""; // Wenn die Eingabe ungültig ist, gib einen leeren String zurück
      }

      // Prüfe, ob der Schlüssel im Objekt vorhanden ist
      if (key in inputObj) {
        return inputObj[key];
      } else {
        return ""; // Wenn der Schlüssel nicht im Objekt vorhanden ist, gib einen leeren String zurück
      }
    },
  },
  mixins: [MinimumWageMixin],
  // props: {
  //   canUserEdit: {
  //     type: Boolean,
  //     default: false,
  //   },
  //},
  data() {
    return {
      isLoading: false,
      errorObject: null,
      resourceCalendars: [],
      totalNumberOfResults: 0,
      holidaysInWorkingDays: 0,
      sortOrder: 0,
      sortedProperty: "",
      selectedLocations: {},
      resourceCalendarToDeleteId: 0,
      resourceCalendarToEdit: null,
      expandedPanels: [],
      isLoadingTreeView: {},
      fullLocationTree: [],
      selectedLocation: [],
      groupingOptions: [],
      locationAccurationOptions: [],
      languageOptions: [
        { value: "de-CH", text: "Deutsch" },
        { value: "fr-CH", text: "Französisch" },
        { value: "it-CH", text: "Italienisch" },
      ],
      selectedLanguage: "de-CH",
      workday: null,
      selectedGroupingOption: null,
      cityFilterOptions: [],
      selectedCityFilter: null,
      isLoadingImport: false,
      searchFrom: new Date().toISOString().substr(0, 10),
      searchTo: new Date().toISOString().substr(0, 10),
      yearSelection: [new Date().getFullYear()],
      selectedYear: null,
      previousSelection: [],
      isUpdating: false,
      publicHolidayConfig: null, // Neue Variable zum Speichern der Konfiguration
    };
  },
  watch: {
    "$store.state.mindestLohnKonfiguration.Configuration": function () {
      this.errorObject = null;
      this.getPossibleYears();
      this.selectedYear = this.yearSelection
        ? this.yearSelection.find((x) => x === new Date().getFullYear())
        : null;
      this.setDateRangetoYear(this.selectedYear);
    },
  },
  created() {
    this.loadHolidayOverview();
  },
  methods: {
    loadHolidayOverview() {
      this.isLoading = true;
      this.getPossibleYears();
      this.selectedYear = this.yearSelection
        ? this.yearSelection.find((x) => x === new Date().getFullYear())
        : null;
      this.setDateRangetoYear(this.selectedYear);
      this.createFullLocationTree();
      this.getGroupingOptions();
      this.getLocationAccurationOptions();
      this.loadPublicholidayConfig(); // Laden der Konfiguration beim Initialladen
      this.loadCities();
    },
    getCalenders() {
      this.isLoading = true;
      GetConfigPublicHolidays(
        this.$store.state.mindestLohnKonfiguration.BasicContractInformation
          .contractNumber,
        this.$store.state.mindestLohnKonfiguration.BasicContractInformation
          .contractVersion,
        this.editionId,
        this.$store.state.mindestLohnKonfiguration.Configuration.id,
        this.searchFrom,
        this.searchTo,
        this.selectedLanguage,
        this.workday,
        this.selectedGroupingOption,
        this.selectedCityFilter,
        (response) => {
          this.resourceCalendars = response;
          this.totalNumberOfResults = response.length;
          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    createFullLocationTree() {
      let cityData = this.$store.state.mindestLohnKonfiguration.Cities;
      this.fullLocationTree = CreateMiloTreeView(cityData);
    },
    handleNewSelection(newValue) {
      if (this.isUpdating) {
        this.isUpdating = false;
        return;
      }

      // Finden Sie den Unterschied zwischen der neuen und der vorherigen Auswahl
      const latestValue = newValue.find(
        (value) => !this.previousSelection.includes(value),
      );
      const removedValue = this.previousSelection.find(
        (value) => !newValue.includes(value),
      );

      if (latestValue) {
        // Hinzufügen des neuen Werts zur aktuellen Auswahl, falls vorhanden
        this.selectedLocation = [latestValue];
      } else if (removedValue) {
        // Entfernen des de-selektierten Werts aus der aktuellen Auswahl
        const index = this.selectedLocation.indexOf(removedValue);
        if (index > -1) {
          this.selectedLocation.splice(index, 1);
        }
      }

      this.previousSelection = [...newValue];
      this.getCalenders();
    },

    changeSelectedLocationFilter(newFilter) {
      this.selectedCityFilter = newFilter;
      this.getCalenders();
    },
    changeLanguage(newLanguage) {
      this.selectedLanguage = newLanguage;
      this.getCalenders();
    },
    changeGrouping(newGrouping) {
      this.selectedGroupingOption = newGrouping;
      this.getCalenders();
    },
    getGroupingOptions() {
      GetGroupByOptions(
        (response) => {
          this.groupingOptions = Object.keys(response).map((x) => {
            return {
              text: response[x],
              value: parseInt(x),
            };
          });
          //Set Default Grouping to Year (Year=1)
          this.changeGrouping(1);
        },
        (error) => {
          this.errorObject = error;
        },
      );
    },
    getLocationAccurationOptions() {
      GetLocationAccurationOptions(
        (response) => {
          this.locationAccurationOptions = Object.keys(response).map((x) => {
            return {
              text: response[x],
              value: parseInt(x),
            };
          });
        },
        (error) => {
          this.errorObject = error;
        },
      );
    },
    loadCities() {
      GetCitiesVNext(
        this.contractId,
        this.versionId,
        this.$store.state.mindestLohnKonfiguration.Configuration.editionId,
        (response) => {
          this.cityFilterOptions = response.map((x) => {
            return {
              id: x.cityId,
              text: x.cityValue,
              path: x.path,
            };
          });
        },
        (error) => {
          this.PlzErrorObject = error;
        },
      );
    },
    loadPublicholidayConfig() {
      GetPublicholidayConfig(
        this.$store.state.mindestLohnKonfiguration.BasicContractInformation
          .contractNumber,
        this.$store.state.mindestLohnKonfiguration.BasicContractInformation
          .contractVersion,
        this.editionId,
        this.$store.state.mindestLohnKonfiguration.Configuration.id,
        (response) => {
          if (response) {
            this.workday = response.workingDaysType;
          }
          this.publicHolidayConfig = response; // Speichern der Konfiguration
          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    setDateRangetoYear(year) {
      this.searchFrom = new Date(year, 0, 2).toISOString().substr(0, 10);
      this.searchTo = new Date(year, 11, 32).toISOString().substr(0, 10);
      this.getCalenders();
    },
    getPossibleYears() {
      let configurationId =
        this.$store.state.mindestLohnKonfiguration.Configuration.id;
      if (!configurationId) {
        return;
      }

      if (configurationId && configurationId != undefined) {
        GetPublicHolidayYears(
          configurationId,
          (response) => {
            this.yearSelection = response;
          },
          (error) => {
            this.errorObject = error;
          },
        );
      }
    },
  },
};
</script>

<style scoped>
.custom-td {
  vertical-align: top;
}

.calenderOverview {
  font-size: small;
  table-layout: fixed;
}

.calenderOverview thead th:nth-child(1) {
  width: 7%;
}

.calenderOverview thead th:nth-child(2) {
  width: 20%;
}

.calenderOverview thead th:nth-child(3) {
  width: 10%;
}

.calenderOverview thead th:nth-child(4) {
  width: 30%;
}

.calenderOverview thead th:nth-child(5) {
  width: 10%;
}

.calenderOverview tbody tr {
  border-bottom: 1px solid gainsboro;
}

.calenderOverview td,
.calenderOverview th {
  padding: 8px 4px;
}

.calenderOverview-wrapper {
  max-height: 70vh;
  overflow-y: auto;
}

.calenderOverview thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: #fff;
}

/deep/ a:hover {
  color: #0056b3;
  text-decoration: underline;
}
</style>
